import { Box, Typography, useTheme } from '@mui/material';
import { InboxOutlined } from '@mui/icons-material';
import type { ReactNode } from 'react';

interface EmptyStateProps {
  text: string;
  icon?: ReactNode;
  variant?: 'default' | 'compact';
}

export default function EmptyState({ text, icon, variant = 'default' }: EmptyStateProps) {
  const theme = useTheme();
  const isCompact = variant === 'compact';

  const defaultIcon = (
    <InboxOutlined
      sx={{
        fontSize: isCompact ? 32 : 48,
        color: 'text.disabled',
        opacity: 0.6,
      }}
    />
  );

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: isCompact ? 4 : 6,
        px: 3,
        textAlign: 'center',
        minHeight: isCompact ? 120 : 200,
        borderRadius: 2,
        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.02)' : 'rgba(0, 0, 0, 0.02)',
        border: `1px dashed ${theme.palette.divider}`,
      }}
    >
      <Box sx={{ mb: isCompact ? 1.5 : 2 }}>{icon || defaultIcon}</Box>
      <Typography
        variant={isCompact ? 'body1' : 'h6'}
        color="text.secondary"
        sx={{
          fontWeight: isCompact ? 'normal' : 'medium',
          maxWidth: 300,
          lineHeight: 1.4,
        }}
      >
        {text}
      </Typography>
    </Box>
  );
}
